import { SignalsMessageRequest } from '../models/signalMessages';

const fetcher = async (user, messageId, status): Promise<any> => {
	await fetch(
		`${process.env.REACT_APP_GATEWAY_URL}${window.config.Endpoints.SignalBookmark}`,
		{
			method: status ? 'DELETE' : 'POST',
			headers: {
				Accept: 'application/json',
				Authorization: `bearer ${user?.token}`,
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ messageId } as SignalsMessageRequest)
		}
	);
	return messageId;
};

export async function setBookmarkedSignals(
	user,
	messageId: string,
	status: boolean
): Promise<any> {
	return fetcher(user, messageId, status);
}
